var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudComputing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cloud-computing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.979,
    height: 32,
    viewBox: "0 0 43.979 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33198",
    "data-name": "Group 33198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70454",
    "data-name": "Path 70454",
    d: "M34.363,98.65H24.928V89.116h3.118a.975.975,0,0,0,.791-1.546l-6.066-8.393a.967.967,0,0,0-1.573,0L15.133,87.57a.973.973,0,0,0,.791,1.546h3.118V98.65H8.474C3.756,98.389,0,93.977,0,89.2a8.952,8.952,0,0,1,4.439-7.728,6,6,0,0,1-.368-2.094,6.086,6.086,0,0,1,6.093-6.093,5.989,5.989,0,0,1,2.085.368,12.2,12.2,0,0,1,23.176,4.026,10.611,10.611,0,0,1-1.06,20.974Z",
    transform: "translate(0 -66.65)",
    fill: "#5076ba"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudComputing);
export default __webpack_public_path__ + "static/media/cloud-computing.7a102fb66305789d8a2075d0be5c7f0b.svg";
export { ForwardRef as ReactComponent };